var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("summary-partner-control", {
        attrs: {
          partner: _vm.partner,
          title: "SummaryReport.Partners.Partner",
          index: _vm.index,
          isContinuousReport: true
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "group-content" },
        [
          _vm.hasTargets
            ? _c("check-box-dialog-row", {
                attrs: {
                  id: "targetsDialog" + _vm.index,
                  title:
                    "ContinuousReport.Collaboration.Partners.TargetsRelated",
                  buttonLabel: "ContinuousReport.Button.SelectTarget",
                  displayOptionNames: false,
                  options: _vm.targets,
                  required: true
                },
                model: {
                  value: _vm.partner.targets,
                  callback: function($$v) {
                    _vm.$set(_vm.partner, "targets", $$v)
                  },
                  expression: "partner.targets"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("check-box-dialog-row", {
            attrs: {
              id: "targetGroupsDialog" + _vm.index,
              title:
                "ContinuousReport.Collaboration.Partners.TargetGroupsRelated",
              buttonLabel: "ContinuousReport.Button.SelectTargetGroup",
              displayOptionNames: true,
              options: _vm.targetGroups,
              required: true
            },
            model: {
              value: _vm.partner.targetGroups,
              callback: function($$v) {
                _vm.$set(_vm.partner, "targetGroups", $$v)
              },
              expression: "partner.targetGroups"
            }
          }),
          _vm._v(" "),
          _vm.showRedirectedCustomerFields
            ? _c(
                "div",
                [
                  _c("radio-button-row", {
                    key: _vm.radioButtonValueChanged + _vm.index,
                    attrs: {
                      title:
                        "ContinuousReport.Collaboration.Partners.RedirectedCustomersWereCounted",
                      componentIndex: _vm.index,
                      required: false
                    },
                    model: {
                      value: _vm.partner.redirectedCustomersWereCounted,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.partner,
                          "redirectedCustomersWereCounted",
                          $$v
                        )
                      },
                      expression: "partner.redirectedCustomersWereCounted"
                    }
                  }),
                  _vm._v(" "),
                  _vm.partner.redirectedCustomersWereCounted
                    ? _c(
                        "div",
                        [
                          _c("numeric-input-row", {
                            attrs: {
                              title:
                                "ContinuousReport.Collaboration.Partners.RedirectedCustomersToPartner",
                              id: "customerstopartnercount" + _vm.index
                            },
                            model: {
                              value:
                                _vm.partner.redirectedCustomersToPartnerCount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.partner,
                                  "redirectedCustomersToPartnerCount",
                                  $$v
                                )
                              },
                              expression:
                                "partner.redirectedCustomersToPartnerCount"
                            }
                          }),
                          _vm._v(" "),
                          _c("numeric-input-row", {
                            attrs: {
                              title:
                                "ContinuousReport.Collaboration.Partners.RedirectedCustomersFromPartner",
                              id: "customersfrompartnercount" + _vm.index
                            },
                            model: {
                              value:
                                _vm.partner.redirectedCustomersFromPartnerCount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.partner,
                                  "redirectedCustomersFromPartnerCount",
                                  $$v
                                )
                              },
                              expression:
                                "partner.redirectedCustomersFromPartnerCount"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }